import styled from 'styled-components';
export const CoHostTooltipWrapper = styled.div.withConfig({
  displayName: "CoHostTooltipstyle__CoHostTooltipWrapper"
})(["position:relative;height:inherit;"]);